<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <div v-if="paymentMethodesData">
      <PaymentMethodesTable
        :paymentMethodesData="paymentMethodesData"
        :paymentMethodeData="paymentMethodeData"
        v-on:setPaymentMethodeData="paymentMethodeData.fillData($event)"
      />

      <Pagination
        v-if="!isLoading"
        :paginationData="paginationData"
        v-on:changePage="changePage"
      />
      <PaymentMethodeInfo :paymentMethodeData="paymentMethodeData" />
      <PaymentMethodeDelete
        :paymentMethodeData="paymentMethodeData"
        v-on:refresh="getAllPaymentMethodes()"
      />
    </div>

    <PaymentMethodeBtns :textSearch="textSearch" v-on:search="search" />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import PaymentMethodesTable from "@/components/settings/settingsOther/paymentMethodes/PaymentMethodesTable.vue";
import PaymentMethodeInfo from "@/components/settings/settingsOther/paymentMethodes/PaymentMethodeInfo.vue";
import PaymentMethodeDelete from "@/components/settings/settingsOther/paymentMethodes/PaymentMethodeDelete.vue";
import PaymentMethodeBtns from "@/components/settings/settingsOther/paymentMethodes/PaymentMethodeBtns.vue";
import Pagination from "@/components/general/Pagination.vue";
import PaymentMethode from "@/models/settings/settingsOther/paymentMethodes/PaymentMethode";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "PaymentMethodes",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    PaymentMethodesTable,
    PaymentMethodeInfo,
    PaymentMethodeDelete,
    PaymentMethodeBtns,
    Pagination,
  },
  data() {
    return {
      isLoading: true,
      exceptionMsg: null,
      exceptionImg: null,
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken,
      language: localStorage.getItem("userLanguage") || "ar",
      textSearch: "",
      paginationData: {
        totalPages: 1,
        totalItems: 0,
        countItemsInPage: 0,
        selfPage: 1,
      },
      paymentMethodesData: null,
      paymentMethodeData: new PaymentMethode(),
    };
  },
  methods: {
    changePage(page) {
      this.paginationData.selfPage = page;
      this.getAllPaymentMethodes();
    },
    search(text) {
      this.textSearch = text;
      this.getAllPaymentMethodes();
    },
    async getAllPaymentMethodes() {
      this.isLoading = true;
      try {
        const response = await this.paymentMethodeData.getAllPaymentMethodes(
          this.language,
          this.userAuthorizeToken,
          this.selfPage,
          this.textSearch
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.exceptionMsg = null;
          this.paginationData = {
            totalPages: response.data.pagination.totalPages,
            totalItems: response.data.pagination.totalItems,
            countItemsInPage: response.data.pagination.countItemsInPage,
            selfPage: response.data.pagination.selfPage,
          };
          this.paymentMethodesData = response.data.paymentMethodesData;
        } else if (response.data.status == STATUS.NO_CONTENT) {
          this.paymentMethodesData = null;
          this.exceptionMsg = response.data.msg;
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.paymentMethodesData = null;
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.paymentMethodesData = null;
          this.exceptionMsg = response.data.msg;
          this.showMsg(response.data.msg);
        }
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
        this.paymentMethodesData = null;
      }
      this.isLoading = false;
    },
  },
  computed: {},
  async created() {
    this.getAllPaymentMethodes();
  },
};
</script>
